import {AbstractJavascriptFunctionCallVO} from "./AbstractJavascriptFunctionCallVO";
import {JavascriptFunctionName} from "../JavascriptFunctionName";

export class JavascriptCallOnRegisterCompleteVO implements AbstractJavascriptFunctionCallVO {


    public functionName = JavascriptFunctionName.ON_REGISTER_COMPLETE;
    public parameters = [];

    /**
     * Defines parameters needed for calling "ggsOnRegisterComplete" javascript function.
     *
     * Full documentation for javascript/flash interface see:
     * https://docs.google.com/a/goodgamestudios.com/document/d/1YEQHq6cQ3IsCBrwj2VO3nPe4Qu7JarFzKZWP2AgTQc0/edit
     *
     * @param accountId (String)
     * @param playerId (int)
     * @param instanceId (int)
     * @param networkId (int)
     * @param gameId (int)
     */
    constructor(accountId: string, playerId: number, instanceId: number, networkId: number, gameId: number) {
        this.parameters.push(accountId, playerId, instanceId, networkId, gameId);
    }
}

